(() => {
  const VARIANT_MEDIA_KEYWORDS = {
    "loaded-protein": {
      "Jet-Puffed(TM) Marshmallow": ["jp_m", "jetpuffed"],
      "Cinnamon Toast": ["ct", "cinnamon"],
      "Vanilla Ice Cream": ["vic"],
      "Milk Chocolate": ["mc"],
      "Lemon Cake by Casey Kelly": ["lc"],
      "Blueberry Muffin": ["bbm", "bm"],
      "Chocolate Cookie Blast": ["ccb"],
      "Mint Chip Ice Cream": ["mci"],
      "Little Debbie(R) Strawberry Shortcake Rolls": ["ssr"],
      "Chocolate Peanut Butter Cup": ["pbc"],
      "Vanilla Peanut Butter": ["vpb"],
      "Skippy(R) Peanut Butter Flavor": ["pb"],
      "Little Debbie(R) Cosmic Brownies": ["cb"],
      "Fruity Crunch": ["fc"],
      "Maple Glazed Donut by Nic Stella (RYSE CEO)": ["mgd"],
      "Banana Pudding by Noel Deyzel": ["bp"],
      "Raspberry Tart by FFGF": ["rt"],
      "Little Debbie(R) Pumpkin Spice Rolls": ["psr"],
      "Little Debbie(R) Christmas Tree Cakes": ["ctc"],
      "Jet-Puffed(TM) Birthday Cake": ["jp_bc"]
    },
    "ryse-fuel-energy-drink": {
      "Kool-Aid(TM) Tropical Punch": ["katp"],
      "Kool-Aid(TM) Grape": ["kag"],
      "Root Beer Float": ["rbf"],
      "Frosted Lemonade": ["fl_"],
      "SunnyD(TM) Tangy Original": ["sdto"],
      "Sour Punch(R) Sour Blue Raspberry": ["spbr"],
      "Sour Punch(R) Sour Green Apple": ["spga"],
      "Sour Punch(R) Sour Strawberry": ["sps"],
      "Ring-Pop(R) Cherry": ["rpc"],
      "Cherry Limeade": ["cl_"],
      "Cotton Candy": ["cc"],
      "Arctic Berry": ["ab"],
      "Variety Pack": ["tray"],
      "Firecracker": ["fire"]
    },
    "ryse-energy-drink": {
      "Orange Cream": ["orangecream"],
      "Pink Lemonade": ["pinklemonade"],
      "Cherry Limeade": ["cherrylimeade"],
      "Ocean Breeze": ["oceanbreeze"],
      "Strawberry Watermelon": ["can_long_sw"],
      "Variety Pack": ["tray"]
    }
  };

  const ready = () => {
    initHeader();
    initScrollTracks();
    initAccordions();
    initTabs();
    initHomeTileImageFallbacks();
    initProductCardSwatches();
    initProductRoots();
    initStackBuilder();
    initAnchorScroll();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready, { once: true });
  } else {
    ready();
  }

  function qs(selector, root = document) {
    return root.querySelector(selector);
  }

  function qsa(selector, root = document) {
    return Array.from(root.querySelectorAll(selector));
  }

  function normalizeToken(value) {
    return String(value || "")
      .replace(/™/g, "(TM)")
      .replace(/®/g, "(R)")
      .replace(/[^a-z0-9()]+/gi, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function moneyFromCents(cents) {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(amount);
  }

  function priceHtml(value) {
    const text = String(value || "").trim();
    if (!text) return "";

    const parts = text.split(".");
    const major = parts[0] || text;
    const minor = parts.length > 1 ? parts.slice(1).join(".") : "";
    return minor
      ? `<span class="ryse-price__major">${major}</span><span class="ryse-price__minor">${minor}</span>`
      : `<span class="ryse-price__major">${major}</span>`;
  }

  function initProductCardSwatches() {
    qsa(".ryse-card[data-product-handle]").forEach((card) => {
      const mediaImage = qs(".ryse-card__media img", card);
      const variantLabel = qs("[data-card-variant-label]", card);
      const currentPrice = qs("[data-card-price-current]", card);
      const comparePrice = qs("[data-card-price-compare]", card);
      const links = qsa("[data-ryse-card-link]", card);
      const swatches = qsa("[data-ryse-card-swatch]", card);

      swatches.forEach((swatch) => {
        swatch.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          const variantImage = swatch.dataset.variantImage;
          const variantUrl = swatch.dataset.variantUrl;
          const variantTitle = swatch.dataset.variantTitle;
          const variantPrice = swatch.dataset.variantPrice;
          const variantCompare = swatch.dataset.variantCompare;

          if (mediaImage && variantImage) {
            mediaImage.src = variantImage;
            mediaImage.removeAttribute("srcset");
            mediaImage.alt = swatch.dataset.variantImageAlt || variantTitle || mediaImage.alt;
          }

          if (variantUrl) {
            links.forEach((link) => link.setAttribute("href", variantUrl));
          }

          if (variantLabel && variantTitle) {
            variantLabel.textContent = variantTitle;
          }

          if (currentPrice && variantPrice) {
            currentPrice.innerHTML = priceHtml(variantPrice);
          }

          if (comparePrice) {
            comparePrice.innerHTML = variantCompare ? priceHtml(variantCompare) : "";
            comparePrice.hidden = !variantCompare;
          }

          swatches.forEach((item) => {
            item.classList.toggle("is-active", item === swatch);
          });
        });
      });
    });
  }

  function initHomeTileImageFallbacks() {
    const sourceRoot = "https://cdn.shopify.com/s/files/1/2316/6807/files/";

    qsa(".ryse-home-tile__asset").forEach((media) => {
      if (!(media instanceof HTMLImageElement)) return;

      const rawSource = media.getAttribute("src") || "";
      if (!rawSource.includes("/cdn/shop/files/")) return;

      const filename = rawSource.split("/cdn/shop/files/").pop();
      if (!filename) return;

      const replacement = `${sourceRoot}${filename}`;
      media.src = replacement;
      media.removeAttribute("srcset");
      media.dataset.ryseTileFallback = "official-cdn";
    });
  }

  function initHeader() {
    const drawer = qs("[data-ryse-drawer]");
    const backdrop = qs("[data-ryse-drawer-backdrop]");
    const toggle = qs("[data-ryse-drawer-toggle]");
    const close = qs("[data-ryse-drawer-close]");
    const searchToggle = qs("[data-ryse-search-toggle]");
    const searchPanel = qs("[data-ryse-search-panel]");
    const desktopTriggers = qsa("[data-ryse-menu-trigger]");
    const desktopDrawers = qsa("[data-ryse-menu-drawer]");
    const desktopMenuQuery = window.matchMedia("(min-width: 900px)");

    if (toggle && drawer && backdrop) {
      const setDrawer = (open) => {
        drawer.classList.toggle("is-open", open);
        backdrop.classList.toggle("is-open", open);
        document.body.classList.toggle("overflow-hidden", open);
      };

      toggle.addEventListener("click", () => setDrawer(true));
      close?.addEventListener("click", () => setDrawer(false));
      backdrop.addEventListener("click", () => setDrawer(false));
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          setDrawer(false);
          searchPanel?.classList.remove("is-open");
          closeDesktopMenus();
        }
      });
    }

    qsa("[data-ryse-drawer-parent]").forEach((parent) => {
      const button = qs("[data-ryse-drawer-parent-toggle]", parent);
      const children = qs("[data-ryse-drawer-children]", parent);
      if (!button || !children) return;
      button.addEventListener("click", () => {
        const isHidden = children.hasAttribute("hidden");
        qsa("[data-ryse-drawer-children]").forEach((panel) => {
          if (panel !== children) panel.setAttribute("hidden", "");
        });
        qsa("[data-ryse-drawer-parent]").forEach((item) => item.classList.remove("is-open"));
        if (isHidden) {
          children.removeAttribute("hidden");
          parent.classList.add("is-open");
        } else {
          children.setAttribute("hidden", "");
          parent.classList.remove("is-open");
        }
      });
    });

    const closeDesktopMenus = () => {
      desktopTriggers.forEach((trigger) => {
        trigger.setAttribute("aria-expanded", "false");
        trigger.closest(".ryse-header__nav-item")?.classList.remove("is-open");
      });
      desktopDrawers.forEach((panel) => {
        panel.classList.remove("is-open");
        panel.setAttribute("aria-hidden", "true");
      });
      document.body.classList.remove("ryse-desktop-menu-open");
    };

    const positionDesktopMenu = (button, panel) => {
      const header = button.closest(".ryse-header");
      const main = button.closest(".ryse-header__main");
      const rect = button.getBoundingClientRect();
      const headerRect = header?.getBoundingClientRect();
      const mainRect = main?.getBoundingClientRect();
      const panelWidth = Math.min(430, window.innerWidth - 32);
      const left = Math.max(16, Math.min(rect.left, window.innerWidth - panelWidth - 16));
      const top = Math.max(mainRect?.bottom || headerRect?.bottom || rect.bottom, rect.bottom);
      panel.style.setProperty("--ryse-menu-left", `${left}px`);
      panel.style.setProperty("--ryse-header-drawer-top", `${top}px`);
    };

    desktopTriggers.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        if (!desktopMenuQuery.matches) {
          closeDesktopMenus();
          return;
        }
        const panelId = button.getAttribute("data-ryse-menu-trigger");
        const panel = panelId ? document.getElementById(panelId) : null;
        const shouldOpen = panel && !panel.classList.contains("is-open");
        closeDesktopMenus();
        if (panel && shouldOpen) {
          positionDesktopMenu(button, panel);
          button.setAttribute("aria-expanded", "true");
          button.closest(".ryse-header__nav-item")?.classList.add("is-open");
          panel.classList.add("is-open");
          panel.setAttribute("aria-hidden", "false");
          document.body.classList.add("ryse-desktop-menu-open");
          searchPanel?.classList.remove("is-open");
        }
      });
    });

    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest(".ryse-header__nav") || target.closest("[data-ryse-menu-drawer]")) return;
      closeDesktopMenus();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeDesktopMenus();
    });

    closeDesktopMenus();
    window.addEventListener("resize", closeDesktopMenus);
    desktopMenuQuery.addEventListener?.("change", closeDesktopMenus);

    searchToggle?.addEventListener("click", () => {
      closeDesktopMenus();
      searchPanel?.classList.toggle("is-open");
      const input = qs("input", searchPanel);
      if (searchPanel?.classList.contains("is-open")) {
        setTimeout(() => input?.focus(), 40);
      }
    });
  }

  function initScrollTracks() {
    qsa("[data-ryse-scroll]").forEach((root) => {
      const track = qs("[data-ryse-scroll-track]", root);
      const previous = qs("[data-ryse-scroll-prev]", root);
      const next = qs("[data-ryse-scroll-next]", root);
      if (!track) return;
      const amount = () => Math.max(track.clientWidth * 0.92, 280);
      previous?.addEventListener("click", () => {
        track.scrollBy({ left: -amount(), behavior: "smooth" });
      });
      next?.addEventListener("click", () => {
        track.scrollBy({ left: amount(), behavior: "smooth" });
      });
    });
  }

  function initAccordions() {
    qsa("[data-ryse-accordion]").forEach((root) => {
      qsa("[data-ryse-accordion-trigger]", root).forEach((button) => {
        button.addEventListener("click", () => {
          const panel = document.getElementById(button.getAttribute("aria-controls"));
          const expanded = button.getAttribute("aria-expanded") === "true";
          button.setAttribute("aria-expanded", String(!expanded));
          if (panel) {
            if (expanded) panel.setAttribute("hidden", "");
            else panel.removeAttribute("hidden");
          }
        });
      });
    });
  }

  function initTabs() {
    qsa("[data-ryse-tabs]").forEach((root) => {
      const buttons = qsa("[data-ryse-tab-button]", root);
      const panels = qsa("[data-ryse-tab-panel]", root);
      if (!buttons.length || !panels.length) return;

      const activate = (id) => {
        buttons.forEach((button) => {
          const active = button.getAttribute("data-ryse-tab-button") === id;
          button.classList.toggle("is-active", active);
          button.setAttribute("aria-selected", String(active));
        });
        panels.forEach((panel) => {
          panel.classList.toggle("is-active", panel.getAttribute("data-ryse-tab-panel") === id);
        });
      };

      buttons.forEach((button) => {
        button.addEventListener("click", () => activate(button.getAttribute("data-ryse-tab-button")));
      });
    });
  }

  function initProductRoots() {
    qsa("[data-ryse-product-root]").forEach((root) => {
      const jsonNode = qs("[data-product-json]", root);
      if (!jsonNode) return;

      let product;
      try {
        product = JSON.parse(jsonNode.textContent || "{}");
      } catch (_error) {
        return;
      }

      const optionButtons = qsa("[data-option-button]", root);
      const hiddenInput = qs('input[name="id"]', root);
      const price = qs("[data-price-current]", root);
      const compare = qs("[data-price-compare]", root);
      const titleTarget = qs("[data-selected-variant-label]", root);
      const addButton = qs("[data-add-button]", root);
      const qtyLabel = qs("[data-qty-label]", root);
      const slides = qsa("[data-ryse-slide]", root);
      const thumbs = qsa("[data-ryse-thumb]", root);
      const prev = qs("[data-ryse-gallery-prev]", root);
      const next = qs("[data-ryse-gallery-next]", root);
      let activeIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
      if (activeIndex < 0) activeIndex = 0;

      const state = {};
      qsa("[data-option-group]", root).forEach((group) => {
        const active = qs("[data-option-button].is-active", group);
        if (active) state[group.getAttribute("data-option-name")] = active.getAttribute("data-option-value");
      });

      const matchVariant = () =>
        product.variants.find((variant) =>
          (variant.options || []).every((optionValue, index) => {
            const optionName = product.options[index];
            return !state[optionName] || state[optionName] === optionValue;
          })
        ) || product.selected_or_first_available_variant || product.variants[0];

      const setActiveSlide = (index) => {
        if (!slides.length) return;
        activeIndex = ((index % slides.length) + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.classList.toggle("is-active", slideIndex === activeIndex));
        thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle("is-active", thumbIndex === activeIndex));
      };

      const findMediaIndexForVariant = (variant) => {
        const featuredImage = variant?.featured_image?.src || variant?.featured_image || "";
        if (featuredImage) {
          const imageName = String(featuredImage).split("?")[0].split("/").pop();
          const directIndex = slides.findIndex((slide) => {
            const mediaUrl = String(slide.getAttribute("data-media-url") || "").split("?")[0];
            return imageName && mediaUrl.includes(imageName);
          });
          if (directIndex >= 0) return directIndex;
        }

        const optionValue = normalizeToken(variant?.option1 || variant?.title || "");
        const handle = product.handle;
        const map = VARIANT_MEDIA_KEYWORDS[handle];
        if (!map) return -1;
        const tokens = map[optionValue];
        if (!tokens) return -1;
        return slides.findIndex((slide) => {
          const url = String(slide.getAttribute("data-media-url") || "").toLowerCase();
          return tokens.some((token) => url.includes(token.toLowerCase()));
        });
      };

      const refresh = () => {
        const variant = matchVariant();
        if (!variant) return;
        if (hiddenInput) hiddenInput.value = String(variant.id);
        if (price) {
          const formattedPrice = moneyFromCents(variant.price);
          if (
            price.classList.contains("ryse-pdp-price") ||
            price.classList.contains("ryse-pdp-clean-price")
          ) {
            price.innerHTML = formattedPrice.replace(/\.([0-9]{2})$/, "<sup>$1</sup>");
          } else {
            price.textContent = formattedPrice;
          }
        }
        if (compare) {
          if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
            compare.textContent = moneyFromCents(variant.compare_at_price);
            compare.hidden = false;
          } else {
            compare.textContent = "";
            compare.hidden = true;
          }
        }
        if (titleTarget) titleTarget.textContent = variant.public_title || variant.title || "";
        if (addButton) {
          addButton.disabled = !variant.available;
          const quantityValue = qs('input[name="quantity"]', root)?.value || "1";
          addButton.innerHTML = variant.available
            ? `${addButton.getAttribute("data-default-label") || "Add to cart"} (<span data-qty-label>${quantityValue}</span>)`
            : "Sold out";
        }
        const mediaIndex = findMediaIndexForVariant(variant);
        if (mediaIndex >= 0) setActiveSlide(mediaIndex);
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", nextUrl.toString());
      };

      optionButtons.forEach((button) => {
        button.addEventListener("click", () => {
          const group = button.closest("[data-option-group]");
          if (!group) return;
          qsa("[data-option-button]", group).forEach((item) => item.classList.remove("is-active"));
          button.classList.add("is-active");
          state[group.getAttribute("data-option-name")] = button.getAttribute("data-option-value");
          refresh();
        });
      });

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener("click", () => setActiveSlide(index));
      });
      prev?.addEventListener("click", () => setActiveSlide(activeIndex - 1));
      next?.addEventListener("click", () => setActiveSlide(activeIndex + 1));

      const qtyInput = qs('input[name="quantity"]', root);
      const qtyMinus = qs("[data-ryse-qty-minus]", root);
      const qtyPlus = qs("[data-ryse-qty-plus]", root);
      const copyToggle = qs("[data-ryse-copy-toggle]", root);
      const copyMore = qs("[data-ryse-copy-more]", root);
      const setQuantity = (nextValue) => {
        if (!qtyInput) return;
        const min = Number(qtyInput.getAttribute("min") || 1);
        const value = Math.max(min, Number(nextValue) || min);
        qtyInput.value = String(value);
        const activeQtyLabel = qs("[data-qty-label]", root);
        if (activeQtyLabel) activeQtyLabel.textContent = String(value);
      };
      qtyMinus?.addEventListener("click", () => setQuantity(Number(qtyInput?.value || 1) - 1));
      qtyPlus?.addEventListener("click", () => setQuantity(Number(qtyInput?.value || 1) + 1));
      copyToggle?.addEventListener("click", () => {
        if (!copyMore) return;
        const expanded = copyToggle.getAttribute("aria-expanded") === "true";
        copyToggle.setAttribute("aria-expanded", expanded ? "false" : "true");
        copyToggle.textContent = expanded ? "Read More..." : "Read Less";
        copyMore.hidden = expanded;
      });

      const form = qs("[data-ryse-add-form]", root);
      form?.addEventListener("submit", async (event) => {
        event.preventDefault();
        const formData = new FormData(form);
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = "Adding...";
        }
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: formData
          });
          if (!response.ok) throw new Error("Cart add failed");
          window.location.href = "/cart";
        } catch (_error) {
          if (addButton) {
            addButton.disabled = false;
            const quantityValue = qs('input[name="quantity"]', root)?.value || "1";
            addButton.innerHTML = `${addButton.getAttribute("data-default-label") || "Add to cart"} (<span data-qty-label>${quantityValue}</span>)`;
          }
        }
      });

      refresh();
    });
  }

  function initStackBuilder() {
    const root = qs("[data-ryse-stack-builder]");
    if (!root) return;

    const state = [];
    const list = qs("[data-stack-items]", root);
    const subtotal = qs("[data-stack-subtotal]", root);
    const savings = qs("[data-stack-savings]", root);
    const total = qs("[data-stack-total]", root);
    const savingsLabel = qs("[data-stack-savings-label]", root);
    const checkout = qs("[data-stack-checkout]", root);

    const discountRate = (count) => {
      if (count >= 4) return 0.2;
      if (count >= 3) return 0.15;
      if (count >= 2) return 0.1;
      return 0;
    };

    const render = () => {
      if (!list || !subtotal || !savings || !total || !checkout || !savingsLabel) return;
      list.innerHTML = "";
      let subtotalValue = 0;
      let itemCount = 0;
      state.forEach((item, index) => {
        subtotalValue += item.price * item.quantity;
        itemCount += item.quantity;
        const row = document.createElement("div");
        row.className = "ryse-stack-builder__summary-row";
        row.innerHTML = `
          <span>${item.title} x ${item.quantity}</span>
          <button type="button" data-remove-index="${index}" class="ryse-card__swatch">Remove</button>
        `;
        list.appendChild(row);
      });
      const rate = discountRate(itemCount);
      const savingsValue = subtotalValue * rate;
      subtotal.textContent = `$${subtotalValue.toFixed(2)}`;
      savings.textContent = `-$${savingsValue.toFixed(2)}`;
      total.textContent = `$${(subtotalValue - savingsValue).toFixed(2)}`;
      savingsLabel.textContent = rate ? `${Math.round(rate * 100)}% bundle preview` : "Add 2+ items to unlock savings";
      checkout.hidden = itemCount === 0;

      qsa("[data-remove-index]", list).forEach((button) => {
        button.addEventListener("click", () => {
          const index = Number(button.getAttribute("data-remove-index"));
          state.splice(index, 1);
          render();
        });
      });
    };

    qsa("[data-stack-add]", root).forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = Number(button.getAttribute("data-variant-id"));
        const title = button.getAttribute("data-title") || "Item";
        const price = Number(button.getAttribute("data-price") || 0);
        const existing = state.find((item) => item.variantId === variantId);
        if (existing) existing.quantity += 1;
        else state.push({ variantId, title, price, quantity: 1 });
        render();
      });
    });

    checkout?.addEventListener("click", async (event) => {
      event.preventDefault();
      if (!state.length) return;
      checkout.textContent = "Building cart...";
      checkout.setAttribute("aria-disabled", "true");
      try {
        await fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } });
        for (const item of state) {
          const formData = new FormData();
          formData.append("id", String(item.variantId));
          formData.append("quantity", String(item.quantity));
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: formData
          });
          if (!response.ok) throw new Error("Add failed");
        }
        window.location.href = "/cart";
      } catch (_error) {
        checkout.textContent = "Checkout";
        checkout.removeAttribute("aria-disabled");
      }
    });

    render();
  }

  function initAnchorScroll() {
    qsa("[data-ryse-scrollto]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const target = document.getElementById(button.getAttribute("data-ryse-scrollto"));
        target?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }
})();
